import { render, staticRenderFns } from "./homeInfo.vue?vue&type=template&id=05b7b104&"
import script from "./homeInfo.vue?vue&type=script&lang=js&"
export * from "./homeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports